import kpiPageCopy from '../../pages/brand/BrandDashboard/BrandKPIs/brandKpiPageCopy';

/** Canonical brand dashboard insight list routes (SEO-friendly slugs). */
export const BRAND_INSIGHT_PATHS = {
  collaborationJourney: '/dashboard/collaboration-journey',
  analytics: '/dashboard/analytics',
  payments: '/dashboard/payments',
};

export const BRAND_ANALYTICS_VIEW_KEYS = [
  'applications',
  'invites',
  'followers',
  'saved',
];

export const BRAND_ANALYTICS_DEFAULT_VIEW = 'applications';

export const BRAND_ANALYTICS_TABS = [
  { value: 'applications', label: 'Application over time' },
  { value: 'invites', label: 'Invites over time' },
  { value: 'followers', label: 'Followers' },
  { value: 'saved', label: 'Saved creators' },
];

export const getBrandInsightPageUrl = (pageKey) => (
  BRAND_INSIGHT_PATHS[pageKey] || ''
);

export function parseBrandAnalyticsView(searchParams) {
  const view = typeof searchParams?.get === 'function'
    ? searchParams.get('view')
    : null;
  return BRAND_ANALYTICS_VIEW_KEYS.includes(view)
    ? view
    : BRAND_ANALYTICS_DEFAULT_VIEW;
}

/** Canonical analytics path including ?view= */
export function getBrandAnalyticsPath(view = BRAND_ANALYTICS_DEFAULT_VIEW) {
  const safeView = BRAND_ANALYTICS_VIEW_KEYS.includes(view)
    ? view
    : BRAND_ANALYTICS_DEFAULT_VIEW;
  return `${BRAND_INSIGHT_PATHS.analytics}?view=${safeView}`;
}

const pageSeo = {
  collaborationJourney: {
    title: 'Campaign Operations',
    description: kpiPageCopy.collaborationJourney.pageIntro,
    canonicalPath: BRAND_INSIGHT_PATHS.collaborationJourney,
  },
  analytics: {
    title: 'Analytics',
    description: 'See who is already trying to build with you.',
    canonicalPath: BRAND_INSIGHT_PATHS.analytics,
  },
  payments: {
    title: 'Payments',
    description: kpiPageCopy.payments.subtitle,
    canonicalPath: BRAND_INSIGHT_PATHS.payments,
  },
};

export const getBrandInsightPageSeo = (pageKey) => pageSeo[pageKey] || null;
